import React from 'react';
import LazyImage from '../../components/LazyImage';

const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-[400px] md:min-h-[448px] lg:h-[448px] flex items-center justify-center">
      {/* Background Image */}
      <LazyImage 
        src="/images/mofu.webp" 
        alt="Financial charts background" 
        className="absolute inset-0 w-full h-full object-cover object-[30%] md:object-center"
        priority={true}
        preload={true}
        sizes="100vw"
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-[#1A2A44] bg-opacity-80 z-10"></div>
      
      {/* Content Overlay */}
      <div className="relative z-20 mx-auto px-4 md:px-10 lg:px-32 w-full py-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Main Title */}
          <h1 className="text-[#FFFFFF] text-[30px] md:text-[42px] lg:text-[37px] font-[700] leading-tight mb-6">
          10 Tips to Increase Your Chance of Scoring a 10x Win with Resource Juniors
          </h1>
          
          {/* Horizontal Line */}
          <div className="w-full h-[2px] bg-[#FFFFFF] mb-6 mx-auto"></div>
          
          {/* Subtitle */}
          <div className="max-w-2xl mx-auto">
            <p className="text-[#FFFFFF] text-[18px] md:text-[22px] lg:text-[24px] font-[400] italic leading-relaxed">
              Practical Insights from a <span className="not-italic font-[600]">25-Year Veteran</span> to Help You Navigate the Junior Mining Space
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
